import { useNavigate } from "react-router";
import { toast } from "sonner";

import { type DossierStatusId, StatusBadge } from "../../status";

interface AanvraagRow {
  ref: string;
  project: string;
  submitted: string;
  updated: string;
  status: DossierStatusId;
  actionRequired: boolean;
}

const ROWS: AanvraagRow[] = [
  {
    ref: "EA-2026-041",
    project: "Social Media & Body Image bij jongeren (kwalitatief onderzoek)",
    submitted: "22 jun 2026",
    updated: "26 jun 2026",
    status: "revisie-gevraagd",
    actionRequired: true,
  },
  {
    ref: "EA-2026-028",
    project: "Voedselkeuze en emoties (online survey)",
    submitted: "10 mei 2026",
    updated: "15 jun 2026",
    status: "goedgekeurd",
    actionRequired: false,
  },
  {
    ref: "EA-2026-017",
    project: "Language preferences for ADHD people / people with ADHD (R2D2-MH)",
    submitted: "9 apr 2026",
    updated: "10 apr 2026",
    status: "goedgekeurd",
    actionRequired: false,
  },
  {
    ref: "EA-2026-015",
    project: "Instagram Recipes & Memory (experiment)",
    submitted: "2 apr 2026",
    updated: "28 apr 2026",
    status: "goedgekeurd",
    actionRequired: false,
  },
  {
    ref: "EA-2026-009",
    project: "Motivational Appeals in Food Advertising (mixed methods)",
    submitted: "20 mrt 2026",
    updated: "5 apr 2026",
    status: "goedgekeurd",
    actionRequired: false,
  },
];

export function MijnAanvragenPage() {
  const navigate = useNavigate();

  const openDossier = (row: AanvraagRow) => {
    if (row.status === "goedgekeurd") {
      toast("Out of Scope", {
        description: "Goedgekeurde dossiers zijn buiten scope voor deze demo.",
      });
      return;
    }
    void navigate(`/dashboard/aanvraag-detail?dossierId=${row.ref}`);
  };

  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Mijn aanvragen</h1>
          <p>Els Vermeersch · Faculteit Sociale Wetenschappen · 5 aanvragen</p>
        </div>
        <button
          className="btn btn--primary"
          onClick={() => void navigate("/dashboard/nieuwe-aanvraag")}
        >
          + Nieuwe aanvraag
        </button>
      </div>

      {/* Action required banner */}
      <div className="panel-navy" style={{ marginBottom: "var(--ua-space)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span style={{ fontSize: "20px" }}>⚠</span>
          <div>
            <div style={{ fontWeight: 600, marginBottom: "2px" }}>Actie vereist (EA-2026-041)</div>
            <div style={{ fontSize: "13px", opacity: 0.85 }}>
              Het secretariaat heeft revisies gevraagd. Bekijk de feedback en dien een aangepaste
              versie in.
            </div>
          </div>
          <button
            className="btn btn--light"
            style={{ marginLeft: "auto", whiteSpace: "nowrap", fontSize: "13px" }}
            onClick={() => void navigate("/dashboard/aanvraag-detail?dossierId=EA-2026-041")}
          >
            Bekijk feedback →
          </button>
        </div>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Referentie</th>
              <th>Project</th>
              <th>Ingediend</th>
              <th>Bijgewerkt</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.ref} style={{ cursor: "pointer" }} onClick={() => openDossier(row)}>
                <td className="ua-muted-xs">
                  {row.ref}
                  {row.actionRequired && (
                    <span
                      className="badge badge--danger"
                      style={{ marginLeft: "6px", fontSize: "10px", padding: "1px 5px" }}
                    >
                      Actie
                    </span>
                  )}
                </td>
                <td style={{ fontSize: "13px", maxWidth: "280px" }}>{row.project}</td>
                <td className="ua-muted-xs">{row.submitted}</td>
                <td className="ua-muted-xs">{row.updated}</td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>
                  <a
                    href="#"
                    className="text-[13px]"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      openDossier(row);
                    }}
                  >
                    Bekijk
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
